(function() {
  'use strict';

  angular.module('ringbaPortal')
    .directive('trActivityFeed', function() {
      return {
        restrict: 'E',
        scope: {},
        controller: ActivityFeedController,
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: '/scripts/components/activity-feed/activity-feed.view.html'
      };
    });

  function ActivityFeedController() {
    'ngInject';

    const vm = this;
    vm.wide = true;
  }
})();
